import React, { useState } from 'react';
import { db } from '../firebase';
import { collection, query, where, getDocs, updateDoc, doc } from 'firebase/firestore';
import '../styles/TrackStatusPage.css';
import HeaderMenu from '../components/HeaderMenu';

function TrackStatusPage() {
  const [searchTerm, setSearchTerm] = useState('');
  const [card, setCard] = useState(null);
  const [loading, setLoading] = useState(false);

  const userRole = localStorage.getItem('userRole'); // Get current role
  const statuses = ['Received', 'Under Process', 'Finished', 'Shipped', 'Delivered'];

  const fetchCard = async () => {
    if (!searchTerm.trim()) return;
    setLoading(true);

    const q = query(
      collection(db, 'jobCards'),
      where('searchKeywords', 'array-contains', searchTerm.toLowerCase())
    );

    try {
      const snapshot = await getDocs(q);
      if (!snapshot.empty) {
        const docSnap = snapshot.docs[0];
        setCard({ id: docSnap.id, ...docSnap.data() });
      } else {
        alert('No job card found.');
        setCard(null);
      }
    } catch (err) {
      console.error('Error fetching card:', err);
      alert('Error fetching data');
    } finally {
      setLoading(false);
    }
  };

  const updateStatus = async (newStatus) => {
    if (!card) return;

    const timestamp = new Date().toLocaleString();
    const newHistoryItem = `${newStatus}|${timestamp}`;

    try {
      const docRef = doc(db, 'jobCards', card.id);
      await updateDoc(docRef, {
        trackingStatus: newStatus,
        trackingHistory: [...(card.trackingHistory || []), newHistoryItem]
      });
      setCard(prev => ({
        ...prev,
        trackingStatus: newStatus,
        trackingHistory: [...(prev.trackingHistory || []), newHistoryItem]
      }));
    } catch (err) {
      console.error('Error updating status:', err);
      alert('Failed to update status.');
    }
  };

  const renderStatusBar = () => {
    const currentIndex = statuses.indexOf(card?.trackingStatus || 'Received');

    return (
      <div className="track-status-bar">
        {statuses.map((status, index) => {
          const isActive = index === currentIndex;
          const isCompleted = index < currentIndex;

          return (
            <div
              key={status}
              className={`track-step ${isActive ? 'active' : ''} ${isCompleted ? 'completed' : ''}`}
              onClick={() => {
                if (userRole === 'reception') updateStatus(status);
              }}
              style={{ cursor: userRole === 'reception' ? 'pointer' : 'default' }}
            >
              <div className="track-step-circle">{index + 1}</div>
              <div className="track-step-label">{status}</div>
            </div>
          );
        })}
      </div>
    );
  };

  const renderHistory = () => {
    const history = card?.trackingHistory || [];
    if (!history.length) return null;

    return (
      <div>
        <h3 className="status-history-title">Status History</h3>
        <div className="status-history">
          {history.map((entry, idx) => {
            const [status, time] = entry.split('|');
            return (
              <div key={idx} className="history-item">
                <strong>{status}</strong>
                <span>{time}</span>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  return (
    <div className="track-container">
      <HeaderMenu />

      <h1 className="track-title">Track Job Card Status</h1>

      <div className="track-search">
        <input
          type="text"
          placeholder="Search by Name or Serial"
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
        />
        <button onClick={fetchCard}>🔍 Search</button>
      </div>

      {loading && <p>Loading...</p>}

      {card && (
        <>
          <div className="job-info">
            <p><strong>Serial:</strong> {card.serial}</p>
            <p><strong>Name:</strong> {card.firstName} {card.lastName}</p>
          </div>

          {renderStatusBar()}
          {renderHistory()}
        </>
      )}
    </div>
  );
}

export default TrackStatusPage;
